export function initSetupGuide(): void {
  if (document.body.dataset.setupGuideBound === "1") return;
  document.body.dataset.setupGuideBound = "1";

  const toggle = (head: HTMLElement) => {
    const card = head.closest<HTMLElement>("[data-setup-guide]");
    card?.classList.toggle("collapsed");
  };

  document.addEventListener("click", (e) => {
    const head = (e.target as HTMLElement).closest<HTMLElement>("[data-guide-toggle]");
    if (head) toggle(head);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const head = (e.target as HTMLElement).closest<HTMLElement>("[data-guide-toggle]");
    if (!head) return;
    e.preventDefault();
    toggle(head);
  });
}
